<template>
  <div>
    <custom-callout :has-toggle="false" class="mb-3 custom-callout">
      <div class="row py-3 m-0">
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Año Académico:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.academicYear | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de Referido:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.referralNumber | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estudiante:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.student | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing text-right">
          <action-button
            id="modal-btn-anadir"
            variant="success pl-1"
            type="button"
            iright="fas fa-file-download"
            @click="downloadFile"
          />
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import documentsService from '@/services/api/document.api';

export default {
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async downloadFile() {
      await documentsService.downloadFromServer(this.item.documentId);
    },
  },
};
</script>

<style>
.border-callout {
  border-color: #b5c3bc;
}
</style>
